import moment from 'moment'
interface ADHDProps {
  patient?: any,
  content?: any,
  logoUrl?: any,
  logoWidth?: any,
  logoHeight?: any,
  signUrl?: any,
  signWidth?: any,
  signHeight?: any,
  fullName?: any,
}

const ASDPreviewTemplate = ({ patient, content, logoUrl, logoWidth, fullName, logoHeight, signUrl, signWidth, signHeight }: ADHDProps) => {

  const displayAge = (dob: string) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  return (
    <div className="d-flex flex-column gap-3 mt-2">
      <div className="w-100 d-flex justify-content-end">
        {
          logoUrl && logoUrl !== "" && <img src={logoUrl} alt='logo' width={logoWidth} height={logoHeight} />
        }
      </div>
      <div className="fw-bold">
        <div>WITHOUT PREJUDICE</div>
        <div>DIAGNOSTIC ASSESSMENT FOR</div>
        <div>AUTISM SPECTRUM DISORDER</div>
      </div>

      <div className='mt-4'>
        <div className="asdTemplate gap-3">
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Name:</span> {`${patient.first_Name} ${patient.last_Name}`}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">DOB:</span> {patient.birthday}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Age:</span>{` ${displayAge(patient.birthday)} years old`}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Phone:</span>{patient?.phonenumber}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Address:</span>{patient?.address}</div>
          {
            patient?.type === "child" && <div className="d-flex align-items-center gap-2"><span className="fw-bold">School:</span>{patient?.school}</div>
          }
          {
            patient?.type === "child" && <div className="d-flex align-items-center gap-2"><span className="fw-bold">Parent:</span>{patient?.school}</div>
          }
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Date of Report:</span>{moment(Date.now()).format("YYYY-MM-DD")}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Date Seen:</span>
            {content.dateSeen}
          </div>
        </div>
      </div>

      <div className="w-100 mt-3">
        <div className="fw-bold">INFORMED CONSENT AND ASSENT</div>
        <div className="mt-2">
          {`${patient.first_Name} ${patient.last_Name} and his parents was fully informed about the purpose of the assessment, the components involved, and the use of the results. It was clearly communicated that this assessment is part of a consensus diagnostic pathway, meaning that the findings would be preliminary and would require further review by a collaborating Developmental Paediatrician for confirmation if needed.`}
          <br />
          <br />
          {`${patient.first_Name} ${patient.last_Name}'s parents confirmed their understanding of this process and signed a Consent Form, acknowledging that they consented to the administration of the assessment and the generation of a report. They also agreed that the report could be shared with them and the referring professional (if applicable) as part of the consensus pathway.`}
          <br />
          <br />
          This report was prepared for the purpose of the client's clinical and/or educational management. The report is not intended for, and is unsuitable for, use in legal proceedings. <br />
          The information contained in this report is sensitive and confidential and must be treated accordingly. The results should only be interpreted by an appropriately trained professional.
        </div>
      </div>

      <div className="w-100 mt-3">
        <div className="fw-bold">Current History Elicited Today:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdCurrentHistory.replace(/\n/g, '<br />') }}></div>
      </div>

      <div className="w-100 mt-3">
        <div className="fw-bold">Report Feedback:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.reportSummary.replace(/\n/g, '<br />') }}></div>
      </div>

      <div className="w-100 mt-3">
        <div className="fw-bold">Developmental History:</div>
        <div className='mt-2'>
          <div>Pregnancy and Birth History:</div>
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdDevPregnancy.replace(/\n/g, '<br />') }}></div>
        </div>
        <div className='mt-4'>
          <div>Gross Motor Skills:</div>
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdDevGross.replace(/\n/g, '<br />') }}></div>
        </div>
        <div className='mt-4'>
          <div>Fine Motor Skills:</div>
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdDevFineMotor.replace(/\n/g, '<br />') }}></div>
        </div>
        <div className='mt-4'>
          <div>Speech and Language Development:</div>
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdDevSpeech.replace(/\n/g, '<br />') }}></div>
        </div>
      </div>

      <div className="w-100 mt-3">
        <div className="fw-bold">DSM-5 Criteria for Autism Spectrum Discorder:</div>
        <div className="mt-2">
          {/* <div>{`The following criteria are addressed below for, based on observation and interview with ${fullName}`}</div> */}
          <div>A criterion is considered met if there is sufficient evidence to support a rating of "2" or "3" based on the following system:</div>
          <br />
          <div>0 = Criterion Not Met</div>
          <div>1 = Criterion Partially Met</div>
          <div>2 = Criterion Met</div>
          <div>3 - Criterion Met to an Extreme Degree</div>
          <div>Please not this rating system is only for the purposes of assigning a rating to each individual criterion, and the “Severity Ratings” for each DSM-5 Section are noted in the table in the summary section of the report</div>
        </div>
      </div>

      <div className="w-100 mt-3">
        <div className="fw-bold" style={{ width: "80%", textAlign: 'center', margin: 'auto' }}>A. Persistent deficits in social communication and social interaction across multiple contexts, as manifested by the following, currently or by history:</div>
        <div className="mt-3">
          1. Deficits in social-emotional reciprocity; ranging from abnormal social approach and failure of normal back-and-forth conversation; to reduced sharing of interests, emotions, or affect; to failure to initiate or respond to social interactions.
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdSocialEmotional.replace(/\n/g, '<br />') }}></div>
          <div><span className='fw-bold'>Criterion</span> {content.asdSocialCreterion || "Not Met"}</div>
        </div>

        <div className="mt-3">
          2. Deficits in nonverbal communicative behaviours used for social interaction, ranging from poorly integrated verbal and nonverbal communication, to abnormalities in eye contact and body language, or deficits in understanding and use of gestures, to a total lack of facial expression and nonverbal communication.
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdNonverbal.replace(/\n/g, '<br />') }}></div>
          <div><span className='fw-bold'>Criterion</span> {content.asdNonverbalCreterion || "Not Met"}</div>
        </div>

        <div className="mt-3">
          3. Deficits in developing, maintaining, and understanding relationships, ranging from difficulties adjusting behaviour to suit various social contexts; to difficulties in sharing imaginative play or in making friends; to absence of interest in peers.
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdDeveloping.replace(/\n/g, '<br />') }}></div>
          <div><span className='fw-bold'>Criterion</span> {content.asdDevelopingCreterion || "Not Met"}</div>
        </div>
      </div>

      <div className='mt-4'>
        <div className="fw-bold" style={{ width: "80%", textAlign: 'center', margin: 'auto' }}>B. Restricted, repetitive patterns of behaviour, interests, or activities, as manifested by at least two of the following, currently or by history:</div>
        <div className="mt-3">
          1. Stereotyped or repetitive motor movements, use of objects, or speech (e.g. simple motor stereotypies, lining up toys or flipping objects, echolalia, idiosyncratic phrases)
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdStereotyped.replace(/\n/g, '<br />') }}></div>
          <div><span className='fw-bold'>Criterion</span> {content.asdStereotypedCreterion || "Not Met"}</div>
        </div>
        <div className="mt-3">
          2. Insistence on sameness, inflexible adherence to routines, or ritualised patterns of verbal or nonverbal behaviour (e.g. extreme distress at small changes, difficulties with transitions, rigid thinking patterns, greeting rituals, need to take same route or eat same food every day).
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdInsistence.replace(/\n/g, '<br />') }}></div>
          <div><span className='fw-bold'>Criterion</span> {content.asdInsistenceCreterion || "Not Met"}</div>
        </div>
        <div className="mt-3">
          3. Highly restricted, fixated interests that are abnormal in intensity or focus (e.g. strong attachment to or preoccupation with unusual objects, excessively circumscribed or perseverative interests).
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdHighly.replace(/\n/g, '<br />') }}></div>
          <div><span className='fw-bold'>Criterion</span> {content.asdHighlyCreterion || "Not Met"}</div>
        </div>
        <div className="mt-3">
          4. Hyper- or hypo-reactivity to sensory input or unusual interest in sensory aspects of environment (such as apparent indifference to pain/temperature, adverse response to specific sounds or textures, excessive smelling or touching of objects, visual fascination with lights or movement).
          <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdHyper.replace(/\n/g, '<br />') }}></div>
          <div><span className='fw-bold'>Criterion</span> {content.asdHyperCreterion || "Not Met"}</div>
        </div>
      </div>

      <div className='mt-4'>
        <div>C. Symptoms must be present in the early developmental period (but may not become fully manifest until social demands exceed limited capacities, or may be masked by learned strategies later in life)</div>
        <div><span className='fw-bold'>Criterion</span> {content.asdSymptomsC || "Not Met"}</div>
      </div>

      <div className='mt-4'>
        <div>D. Symptoms cause clinically significant impairment in social, occupational, or other important areas of current functioning.</div>
        <div><span className='fw-bold'>Criterion</span> {content.asdSymptomsD || "Not Met"}</div>
      </div>

      <div className='mt-4'>
        <div>E. These disturbances are not better explained by intellectual disability or global developmental delay.</div>
        <div><span className='fw-bold'>Criterion</span> {content.asdSymptomsE || "Not Met"}</div>
      </div>

      <div className="mt-4 w-100">
        <table style={{ margin: "0px auto" }}>
          <tbody>
            <tr style={{ border: '1px solid' }}>
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                <div className="d-flex align-items-center">
                  {`Section A (Severity ${content.SectionLeft || "Level 1"})`}
                </div>
              </td>
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-center">
                    {`Section B (Severity ${content.SectionRight || "Level 1"})`}
                  </div>
                </div>
              </td>
            </tr>
            <tr style={{ border: '1px solid', textAlign: 'center' }}>
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                {content.asdSocialCreterion}
              </td>
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                {content.asdStereotypedCreterion}
              </td>
            </tr>
            <tr style={{ border: '1px solid', textAlign: 'center' }} className="px-4 py-2">
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                {content.asdNonverbalCreterion}
              </td>
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                {content.asdInsistenceCreterion}
              </td>
            </tr>
            <tr style={{ border: '1px solid', textAlign: 'center' }} className="px-4 py-2">
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                {content.asdDevelopingCreterion}
              </td>
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                {content.asdHighlyCreterion}
              </td>
            </tr>
            <tr style={{ border: '1px solid', textAlign: 'center' }} className="px-4 py-2">
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                
              </td>
              <td style={{ border: '1px solid' }} className="px-4 py-2">
                {content.asdHyperCreterion}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className='mt-4'>
        <div className="fw-bold">Summary:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdSummary.replace(/\n/g, '<br />') }}></div>
      </div>

      <div className='mt-4'>
        <div className="fw-bold">Follow-Up:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.asdFollowUp.replace(/\n/g, '<br />') }}></div>
      </div>

      <div className='mt-4'>
        <div className="fw-bold">Recommendations:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.additionalRecommendations.replace(/\n/g, '<br />') }}></div>
      </div>

      <div className="lh-lg fw-bold mt-3">
        <div>Kind regards,</div>
        <div className="mt-2">
          {
            signUrl && signUrl !== "" && <img src={signUrl} alt='logo' width={signWidth} height={signHeight} />
          }
        </div>
        <div className="mt-2">{fullName}</div>
        <div>Registered Psychologist</div>
      </div>

    </div>
  )
}

export default ASDPreviewTemplate